<template>
  <TsRow isCentered>
    <TsColumn class="md:is-5">
      <TsSearchWithAlphabetFilter
        @input-search="handleSearchFromInput"
        @filter-search="handleAlphabeticSearch"
        data-testid="brand-listing-page-search-with-alphabet"
        :data-to-filter-array="BrandNames"
        placeholder="Search Brand"
      >
        <template #input-footer>
          <TsTabsCategorySelection class="mt-6" :tabs="chips" />
        </template>
      </TsSearchWithAlphabetFilter>
    </TsColumn>
  </TsRow>
  <TsPopularBrandSection :brandData="filteredBrandData" />
</template>

<script setup lang="ts">
import brands_data from "~/json/brands_listing.json";

const TsSearchWithAlphabetFilter = defineAsyncComponent(
    () => import('~/components/organisms/TsSearchWithAlphabetFilter.vue')
);

const TsTabsCategorySelection = defineAsyncComponent(
    () => import('~/components/molecules/TsTabsCategorySelection.vue')
);

const TsPopularBrandSection = defineAsyncComponent(
    () => import('~/components/organisms/TsPopularBrandSection.vue')
);

const filteredBrandData = ref();

const chips = ["Popular", "Only at Toolstation", "New Additions"];

type Brand = {
  id: number;
  color: string;
  alt: string;
  url: string;
  title: string;
  image: string;
  tag: string;
};
type BrandData = {
  brand: Brand;
};

const BrandNames = brands_data.map((item: BrandData) => item.brand.title);

//Function for search using input
const handleSearchFromInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  const searchQuery = input.value.trim().toLowerCase();
  if (searchQuery) {
    filteredBrandData.value = brands_data.filter(
      (item: BrandData) =>
        item.brand.title.toLowerCase().includes(searchQuery) ||
        item.brand.alt.toLowerCase().includes(searchQuery)
    );
  } else {
    filteredBrandData.value = brands_data;
  }
};

// Function for search using Alphabet
const handleAlphabeticSearch = (char: string) => {
  if (char) {
    filteredBrandData.value = brands_data.filter((item: BrandData) =>
      item.brand.title.toLowerCase().startsWith(char.toLowerCase())
    );
  } else {
    filteredBrandData.value = brands_data; // Reset to the full list if no character is provided
  }
};
</script>
